module.exports = __webpack_public_path__ + "img/pr-9.a4ad16e6.png";